import type { GTMEventReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

export default class GTMLoginModel extends GTMBaseModel {
    public static parseToGTMData(): GTMEventReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'web_event',
            ga4_event_name: 'login'
        };
    }
}
